import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const quizzesApi = createApi({
  reducerPath: 'quizzesApi',
  // Use default keepUnusedDataFor (60s) to avoid thrashing & repeated fetch loops
  tagTypes: ['Quizzes', 'Quiz'],
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getQuizzes: builder.query({
      query: () => ({ url: urls.quizzes }),
      providesTags: (result) =>
        result
          ? [
              { type: 'Quizzes', id: 'LIST' },
              ...(result.map?.((q) => ({ type: 'Quiz', id: q.id })) || []),
            ]
          : [{ type: 'Quizzes', id: 'LIST' }],
    }),
    getQuiz: builder.query({
      query: (id) => ({ url: urls.quizDetail(id) }),
      providesTags: (_, __, id) => [{ type: 'Quiz', id }],
    }),
    saveQuiz: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.quizDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.quizzes,
            method: 'POST',
            data: req.body,
          };
        }
      },
      invalidatesTags: (result, error, arg) => [
        { type: 'Quizzes', id: 'LIST' },
        ...(arg?.id ? [{ type: 'Quiz', id: arg.id }] : []),
      ],
    }),
    deleteQuiz: builder.mutation({
      query(id) {
        return {
          url: urls.quizDetail(id),
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, id) => [
        { type: 'Quizzes', id: 'LIST' },
        { type: 'Quiz', id },
      ],
    }),
  }),
});

export const {
  useGetQuizzesQuery,
  useGetQuizQuery,
  useSaveQuizMutation,
  useDeleteQuizMutation,
} = quizzesApi;
